import { render, staticRenderFns } from "./Form2View.vue?vue&type=template&id=74158847&scoped=true"
import script from "./Form2View.vue?vue&type=script&lang=js"
export * from "./Form2View.vue?vue&type=script&lang=js"
import style0 from "./Form2View.vue?vue&type=style&index=0&id=74158847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74158847",
  null
  
)

export default component.exports